import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M12.8 10.51H3.2a.76.76 0 0 1-.75-.75V5a2.35 2.35 0 0 1 2.36-2.34h6.39A2.35 2.35 0 0 1 13.55 5v4.76a.75.75 0 0 1-.75.75ZM4 9h8.1V5a.84.84 0 0 0-.85-.84H4.81A.85.85 0 0 0 4 5Zm10.8 3.38a.76.76 0 0 0-.75-.75H2a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 .75-.74Z';
const draw24px =
  'M20,16.34H4a.76.76,0,0,1-.75-.75V7.65a3.41,3.41,0,0,1,3.42-3.4H17.33a3.41,3.41,0,0,1,3.42,3.4v7.94A.76.76,0,0,1,20,16.34ZM4.75,14.84h14.5V7.65a1.91,1.91,0,0,0-1.92-1.9H6.67a1.91,1.91,0,0,0-1.92,1.9Zm18,4.16a.76.76,0,0,0-.75-.75H2a.75.75,0,0,0,0,1.5H22A.76.76,0,0,0,22.75,19Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const LaptopIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'laptop'),
) as IconWithRender;

LaptopIcon.displayName = 'LaptopIcon';
LaptopIcon.propTypes = Icon.propTypes;
LaptopIcon.renderIcon = (props) => <LaptopIcon {...props} />;
export default LaptopIcon;
